'use client'

import React, { useState } from 'react'

import { JoinUsNowModal } from 'Components/Blocks/Modals'
import { EventsHeroSection, EventsListSection } from 'Components/Sections'
import { Column } from 'Components/UI'

function EventsPage() {
  const [joinUsModalModalOpened, setJoinUsModalModalOpened] = useState(false)

  return (
    <Column alignCenter fullWidth>
      <EventsHeroSection onAction={() => setJoinUsModalModalOpened(true)} />

      <EventsListSection />

      <JoinUsNowModal
        isOpened={joinUsModalModalOpened}
        onClose={() => setJoinUsModalModalOpened(false)}
      />
    </Column>
  )
}

export default EventsPage
